import { PopupBannerForm } from './PopupBannerForm'
import { withPopupBannerForm } from './withPopupBannerForm'

const ConnectedPopupBannerForm = withPopupBannerForm(PopupBannerForm)
export { ConnectedPopupBannerForm as PopupBannerForm }
